<template>
  <div class="card-body">
    <div class="fs-6 fw-bold text-center text-primary mb-5 my-4">
      <!-- logo otomatis dari backend / fallback -->
      <img :src="preview" alt="Logo Klinik" height="100">
      <div
        class="fs-2 mt-2 fw-normal text-dark"
      >Masuk ke dashboard Anda, kelola aktivitas, dan jadikan hari lebih produktif.</div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">Alamat Email Terdaftar *</label>
        <input
          v-model="form.email"
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          placeholder="Alamat Email Terdaftar..."
          autocomplete="off"
          required
        >
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="form-check"></div>
        <router-link to="/login" class="text-primary fw-bold">Kembali ke halaman Masuk</router-link>
      </div>
      <button type="submit" class="btn btn-primary w-100 py-8 fs-4 mb-4 rounded-2">Masuk</button>
    </form>
    <router-link
      to="/reset-password"
      class="text-primary fw-bold"
    >Ini halaman reset password-nya ya</router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '../config'

export default {
	metaInfo: {
		titleTemplate: 'Login'
	},
	data() {
		return {
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			token: localStorage.getItem('token'),
			showPassword: false,
			form: {
				email: null
			},
			errors: null
		}
	},
	computed: {
		...mapGetters({
			conf: 'location/getConfig'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.conf && this.conf.logo) {
					url = config('api.baseUrl') + 'storage/uploads/' + this.conf.logo
				} else {
					url = this.logoUrl
				}
				return url
			},
			set(value) {
				this.conf.logo = value
			}
		}
	},
	methods: {
		...mapActions('auth', ['forgotpass']),
		onSubmit: function() {
			this.forgotpass({
				email: this.form.email
			})
				.then((res) => {
					let toast = this.$toasted.show(`${res.respond.response}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
				.catch((err) => {
					console.log('vue===========', err)
				})
		}
	},
	created() {
		if (this.token) {
			this.$router.push('/')
		}
	}
}
</script>
